export const locations = [
  {
    id: 'chicago',
    name: 'Chicago Studio',
    displayName: 'West Loop',
    address: {
      street: 'TBA',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60661',
      country: 'USA'
    },
    contact: {
      email: 'help@thesolroom.com',
      phone: '860-328-6854'
    },
    coordinates: {
      lat: 41.8847,
      lng: -87.6439
    },
    mapUrl: 'https://maps.google.com/?q=737+W+Washington+Chicago+IL',
    mapImage: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=600&h=400&fit=crop&q=80',
    hours: {
      monday: '6:00 AM - 9:00 PM',
      tuesday: '6:00 AM - 9:00 PM',
      wednesday: '6:00 AM - 9:00 PM',
      thursday: '6:00 AM - 9:00 PM',
      friday: '6:00 AM - 8:00 PM',
      saturday: '7:00 AM - 6:00 PM',
      sunday: '7:00 AM - 6:00 PM'
    },
    description: 'Our flagship studio in the heart of Chicago\'s West Loop, featuring state-of-the-art equipment and a serene atmosphere for all your movement needs.'
  }
];

// Helper function to get primary location
export const getPrimaryLocation = () => locations[0];

// Helper function to format address
export const formatAddress = (address) => {
  return `${address.street}, ${address.city}, ${address.state} ${address.zipCode}`;
};

// Helper function to format full address
export const formatFullAddress = (address) => {
  return `${address.street}\n${address.city}, ${address.state} ${address.zipCode}\n${address.country}`;
};